

document.addEventListener("DOMContentLoaded", () => {
  const url = new URL(window.location.href);
  url.search = "";
  history.replaceState({}, "", url.toString());
  updateQueryParam();
});



function updateQueryParam(clickedBtn, param, value) {
  const url = new URL(window.location.href);

  // Set or remove param
  if (!value || value === "All") {
    url.searchParams.delete(param);
  } else {
    url.searchParams.set(param, value);
  }

  history.pushState({}, "", url.toString());
  console.log(`Updated URL: ${url.toString()}`);

   // ---- Active class handling ----
  const btnClass = `${param}Btn`;
  const allBtns = document.querySelectorAll(`.${btnClass}`);

  // Remove active from all
  allBtns.forEach(btn => btn.classList.remove("active"));

      // remove active from all swatches
  document.querySelectorAll(".swatch-color.active").forEach(el => {
    el.classList.remove("active");
  });

  // Add active to clicked button
  if (clickedBtn) {
    clickedBtn.classList.add("active");
  }
updateSiteFitAccordion();
  filterSwatches();
  updatePriceRange();
}

function toCamelCase(str) {
  return str
    .toLowerCase()
    .split(/[\s-]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}


function updateSiteFitAccordion() {
  const url = new URL(window.location.href);

  const lengthParam = url.searchParams.get("length")?.toLowerCase() || null;
  const featureParam = url.searchParams.get("feature")?.toLowerCase() || null;
  const waistParam = url.searchParams.get("waist")?.toLowerCase() || null;

  const lengthUl = document.querySelector(".length-ul");
  const featureUl = document.querySelector(".features-ul");
  const waistUl = document.querySelector(".waist-ul");

  const lengthSpan = document.querySelector("#sizeFitLengthText");
  const featureSpan = document.querySelector("#sizeFitFeaturesText");
  const waistSpan = document.querySelector("#sizeFitWaistText");

  // Helper function
  function getAllExceptFirst(ulElement) {
    if (!ulElement) return "";

    const items = [...ulElement.querySelectorAll("li a")]
      .slice(1) // remove first li
      .map(a => a.textContent.trim());

    return items.join(", ");
  }

  // LENGTH filter
  if (lengthParam && lengthParam !== "all") {
   lengthSpan.innerHTML = toCamelCase(lengthParam);
  } else {
    const lengthText = getAllExceptFirst(lengthUl);
     lengthSpan.innerHTML = lengthText;
    // console.log("Length:", lengthText);
  }

  // FEATURE filter
  if (featureParam && featureParam !== "all") {
     if (featureParam === "true") {
  featureSpan.innerHTML = "Pocket";
} else if (featureParam === "false") {
  featureSpan.innerHTML = "No Pocket";
} else {
  featureSpan.innerHTML = "";
}

  } else {
    const featureText = getAllExceptFirst(featureUl);
     featureSpan.innerHTML = featureText;
    // console.log("Feature:", featureText);
  }

  // WAIST filter
  if (waistParam && waistParam !== "all") {
     waistSpan.innerHTML = toCamelCase(waistParam);
  } else {
    const waistText = getAllExceptFirst(waistUl);
     waistSpan.innerHTML = waistText;
    // console.log("Waist:", waistText);
  }
}


function filterSwatches() {
  loadProduct(null,true);
  toggleAddToBag(false);
  const url = new URL(window.location.href);

  const lengthParam = url.searchParams.get("length")?.toLowerCase() || null;
  const sizeParam = url.searchParams.get("size")?.toLowerCase() || null;
  const featureParam = url.searchParams.get("feature")?.toLowerCase() || null;
  const waistParam = url.searchParams.get("waist")?.toLowerCase() || null;

  const onContainer = document.querySelector("#on-swatches");
  const offContainer = document.querySelector("#off-swatches");

  document.querySelectorAll(".swatch-color").forEach(swatch => {
    const parent = swatch.closest(".parent-single-swatch");

    const productLength = (swatch.dataset.productLength || "").toLowerCase();
    const productFeature = (swatch.dataset.productFeature || "").toLowerCase();
    const productWaist = (swatch.dataset.productWaist || "").toLowerCase();

   let productSizes = swatch.dataset.productSize;

// Ensure we end up with an array no matter what
try {
  const parsed = JSON.parse(productSizes || "[]");
  // Shopify sometimes outputs a single string instead of array
  productSizes = Array.isArray(parsed) ? parsed : [parsed];
} catch {
  productSizes = [];
}

// normalize each size
productSizes = productSizes.map(s => (s || "").toString().toLowerCase());


    let show = true;

    // LENGTH filter
    if (lengthParam && lengthParam !== "all") {
      if (productLength !== lengthParam) show = false;
    }

    // SIZE filter
    if (sizeParam && sizeParam !== "all") {
      if (!productSizes.includes(sizeParam)) show = false;
    }

    // FEATURE filter
    if (featureParam && featureParam !== "all") {
      if (productFeature !== featureParam) show = false;
    }

     // waist filter
    if (waistParam && waistParam !== "all") {
      if (productWaist !== waistParam) show = false;
    }

    // MOVE instead of hide
    if (show) {
      if (parent && offContainer.contains(parent)) {
        onContainer.appendChild(parent);
      }
    } else {
      if (parent && !offContainer.contains(parent)) {
        offContainer.appendChild(parent);
      }
    }
  });
}


function updatePriceRange(productId = null) {
  const container = document.querySelector('#on-swatches');
  if (!container) return;

  // If productId is passed → use that swatch’s price directly
  if (productId) {
    const swatch = container.querySelector(`#swatchId-${productId}`);
    if (swatch) {
      const cents = parseInt(swatch.dataset.productPrice, 10);
      if (!isNaN(cents)) {

        const format = (cents) => {
          if (window.Shopify && Shopify.formatMoney) {
            return Shopify.formatMoney(cents, window.theme?.moneyFormat || "{{ amount_no_decimals_with_currency }}");
          }
          return (cents / 100).toFixed(2);
        };

        const priceText = `$${format(cents)}`;

        document.querySelectorAll('.price').forEach(el => {
          el.textContent = priceText;
        });
      }
    }

    return; // stop here — no price range logic
  }

  // ----- Normal Min/Max Logic (when productId is NOT passed) -----
  const swatches = container.querySelectorAll('.swatch-color');
  const prices = [];

  swatches.forEach(swatch => {
    const cents = parseInt(swatch.dataset.productPrice, 10);
    if (!isNaN(cents)) prices.push(cents);
  });

  if (prices.length === 0) return;

  const minPrice = Math.min(...prices);
  const maxPrice = Math.max(...prices);

  const format = (cents) => {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || "{{ amount_no_decimals_with_currency }}");
    }
    return (cents / 100).toFixed(2);
  };

  const priceText = (minPrice === maxPrice)
    ? `$${format(minPrice)}`
    : `$${format(minPrice)} - $${format(maxPrice)}`;

  document.querySelectorAll('.price').forEach(el => {
    el.textContent = priceText;
  });
}

document.addEventListener("click", function (e) {
  const swatch = e.target.closest(".swatch-color");
  if (!swatch) return;

  e.preventDefault();

    // remove active from all swatches
  document.querySelectorAll(".swatch-color.active").forEach(el => {
    el.classList.remove("active");
  });

  // add active to clicked swatch
  swatch.classList.add("active");

  const productId = swatch.dataset.productId;
//   alert(productId);

 const reviewEls = document.querySelectorAll(".reviewText");
const reviewText = swatch.dataset.productReviewText;

reviewEls.forEach(el => {
  el.innerHTML =
    reviewText && reviewText.trim() !== ""
      ? reviewText
      : "+15k 5-Star Reviews";
});


  loadProduct(productId);
});


async function loadProduct(productId, reset = false) {


 const titleEls = document.querySelectorAll(".product-title");
 const descEls = document.querySelectorAll(".product-description");
 const sdescEls = document.querySelectorAll(".product-short-description");
  const skuEl = document.querySelector(".sku");
  const galleryList = document.querySelector(".gallery-list");
  const btnEl = document.querySelector(".add-to-bag");

  // ✅ If reset is requested → clear fields and return
  if (reset) {
  
    titleEls.forEach(el => {
  el.innerHTML = "Womens Compression Leggings";
});
   descEls.forEach(el => {
  el.innerHTML = "";
});
  sdescEls.forEach(el => {
  el.innerHTML = "";
});
    if (skuEl) skuEl.textContent = "";
    if (btnEl) btnEl.setAttribute("href", "#");
    console.log("Product UI reset.");
    return;
  }

  // ✅ Continue only if we actually have a productId
  const swatch = document.querySelector(`.swatch-color[data-product-id="${productId}"]`);
  if (!swatch) {
    console.warn("Swatch not found for product:", productId);
    return;
  }

  const handle = swatch.dataset.productHandle;
  if (!handle) return;

  try {
    const res = await fetch(`/products/${handle}.js`);
    const product = await res.json();

       titleEls.forEach(el => {
  el.innerHTML = product.title;
});


   descEls.forEach(el => {
  el.innerHTML = product.description;
});
sdescEls.forEach(el => {
  const fullText = product.description.replace(/<[^>]*>/g, ''); // strip HTML tags if any
  const words = fullText.split(/\s+/);

  if (words.length > 20) {
    const shortText = words.slice(0, 20).join(' ');
    el.innerHTML = `
      ${shortText}... 
      <a href="#fullproductdes" class="read-more">Read more</a>
    `;
  } else {
    el.innerHTML = fullText;
  }
});

    if (skuEl && product.variants[0]) skuEl.textContent = `SKU: ${product.variants[0].sku}`;
   if (btnEl) {
  btnEl.setAttribute("href", product.url);
  toggleAddToBag(true);
}

galleryList.innerHTML = '';
  product.images.forEach(imgUrl => {
    galleryList.innerHTML += `
      <li>
        <img src="${imgUrl}" alt="${product.title}">
      </li>
    `;
  });


// ✅ Update feature preview images
const firstImage = product.images?.[0];
const lastImage = product.images?.[product.images.length - 1];

const feature2 = document.querySelector("#feature-2 img");
const feature3 = document.querySelector("#feature-3 img");

if (feature2 && firstImage) {
  feature2.src = firstImage;
  feature2.alt = product.title;
}

if (feature3 && lastImage) {
  feature3.src = lastImage;
  feature3.alt = product.title;
}


    updatePriceRange(productId);

  } catch (error) {
    console.error("Error loading product:", error);
  }
}

function toggleAddToBag(show) {
  const btnEl = document.querySelector(".add-to-bag");
  if (!btnEl) return;

  // btnEl.style.display = show ? "block" : "none";
}


document.addEventListener('DOMContentLoaded', function() {

  const buttons = document.querySelectorAll(".add-to-bag");

  buttons.forEach(function (btn) {
    btn.onclick = function (e) {

      if (this.getAttribute("href") === "#") {
        e.preventDefault();

        Swal.fire({
          icon: "error",
          title: "Color Not Selected",
          text: "Please select a color first!",
          confirmButtonColor: "#d33"
        });
      }

    };
  });

});





document.addEventListener('DOMContentLoaded', function() {
    const gallery = document.querySelector('.product-gallery');
    const info = document.querySelector('.product-info');
    
    if (gallery && info) {
        const galleryHeight = gallery.offsetHeight;
        const infoHeight = info.offsetHeight;
        
        if (galleryHeight > infoHeight) {
            info.style.position = 'sticky';
            info.style.top = '20px';
            info.style.alignSelf = 'flex-start';
        } else {
            gallery.style.position = 'sticky';
            gallery.style.top = '20px';
            gallery.style.alignSelf = 'flex-start';
        }
    }
});

